import { Link } from 'react-router-dom';
import type { CaseItem } from '@/lib/caseTypes';
import StatusBadge from '@/components/base/StatusBadge';

type Props = {
  item: CaseItem;
  className?: string;
};

const CaseCard = ({ item, className = '' }: Props) => (
  <article className={`group flex flex-col overflow-hidden rounded-lg border border-background-300/70 bg-background-50 transition-colors hover:border-primary-300 ${className}`}>
    <Link to={`/case/${item.id}`} className="relative block h-44 w-full overflow-hidden md:h-48">
      <img
        src={item.cover}
        alt={`${item.title} - ${item.category}事件配图`}
        title={`${item.title} · 瓜田追踪`}
        className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
      />
      <span className="absolute left-3 top-3">
        <StatusBadge status={item.status} />
      </span>
    </Link>
    <div className="flex flex-1 flex-col p-4">
      <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">{item.category}</span>
        <span>{item.handle}</span>
      </div>
      <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950">
        <Link to={`/case/${item.id}`} className="transition-colors hover:text-primary-700">
          {item.title}
        </Link>
      </h3>
      <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
      <div className="mt-3.5 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1.5">
          <i className="ri-history-line" aria-hidden="true" />
          更新于 {item.updatedAt}
        </span>
        <span className="flex items-center gap-1.5 text-accent-700">
          <i className="ri-loop-left-line" aria-hidden="true" />
          反转 {item.reversal} 次
        </span>
      </div>
    </div>
  </article>
);

export default CaseCard;